export const ja = {
  // Navigation (Japanese)
  explore: '探索',
  search: '検索',
  create: '投稿作成',
  messages: 'メッセージ',
  notifications: '通知',
  settings: '設定',
  profile: 'プロフィール',
  logout: 'ログアウト',
  home: 'ホーム',
  
  // Authentication
  signin: 'サインイン',
  signup: 'サインアップ',
  login: 'ログイン',
  register: '登録',
  email: 'メール',
  password: 'パスワード',
  confirmPassword: 'パスワード確認',
  firstName: '名',
  lastName: '姓',
  forgotPassword: 'パスワードを忘れましたか？',
  alreadyHaveAccount: 'アカウントをお持ちですか？サインイン',
  dontHaveAccount: 'アカウントをお持ちでないですか？サインアップ',
  
  // Posts & Content
  recent: '最近',
  trending: 'トレンド',
  popular: '人気',
  like: 'いいね',
  likes: 'いいね',
  comment: 'コメント',
  comments: 'コメント',
  share: 'シェア',
  delete: '削除',
  edit: '編集',
  post: '投稿',
  posts: '投稿',
  title: 'タイトル',
  content: 'コンテンツ',
  tags: 'タグ',
  noBlogsFound: 'ブログが見つかりません。他のものを検索するか、最初のものを作成してください！',
  
  // AI Assistant
  quickActions: 'クイックアクション',
  writeCaption: 'キャプション作成',
  suggestTopics: 'トピック提案',
  improveContent: 'コンテンツ改善',
  creativeIdeas: 'クリエイティブアイデア',
  clearChat: 'チャットクリア',
  aiWritingAssistant: 'AI執筆アシスタント',
  poweredByGroq: 'GROQ AIを搭載',
  aiGreeting: 'こんにちは！私はあなたのAI執筆アシスタントです。魅力的なコンテンツの作成、キャプションの執筆、投稿トピックの提案、執筆の改善をお手伝いできます。今日は何に取り組みたいですか？',
  askMeToHelp: 'コンテンツ、キャプション、トピック、または執筆についてお手伝いをお求めください...',
  aiThinking: 'AIが考えています...',
  
  // Chat & Messages
  chat: 'チャット',
  noConversationsYet: 'まだ会話がありません',
  ideafluxChat: 'IdeaFluxチャット',
  typeMessage: 'メッセージを入力...',
  sendMessage: 'メッセージ送信',
  connectingToChat: 'チャットに接続中...',
  
  // Notifications
  noNotificationsYet: 'まだ通知がありません。',
  markAllRead: 'すべて既読にする',
  clearAll: 'すべてクリア',
  
  // Settings
  accountSettings: 'アカウント設定',
  displayName: '表示名',
  emailAddress: 'メールアドレス',
  languagePreference: '言語設定',
  privacySecurity: 'プライバシーとセキュリティ',
  notificationPreferences: '通知設定',
  allowDirectMessages: 'ダイレクトメッセージを許可',
  letOthersMessage: '他のユーザーがプライベートメッセージを送信することを許可',
  likesOnPosts: '投稿へのいいね',
  commentsOnPosts: '投稿へのコメント',
  newFollowers: '新しいフォロワー',
  mentions: 'メンション',
  save: '保存',
  deleteAccount: 'アカウント削除',
  
  // Notification descriptions
  getNotifiedWhenSomeone: '誰かが次のことをした時に通知を受け取る',
  likesYourPosts: 'あなたの投稿にいいねする',
  commentsOnYourPosts: 'あなたの投稿にコメントする',
  followsYou: 'あなたをフォローする',
  mentionsYou: 'あなたをメンションする',
  chooseNotifications: '受け取りたい通知を選択してください',
  controlWhoInteracts: 'あなたと交流できる人をコントロールしてください',
  manageAccountInfo: 'アカウント情報と設定を管理してください',
  emailCannotBeChanged: 'セキュリティ上の理由でメールは変更できません',
  
  // Common
  loading: '読み込み中...',
  cancel: 'キャンセル',
  update: '更新',
  submit: '送信',
  back: '戻る',
  next: '次へ',
  previous: '前へ',
  online: 'オンライン',
  offline: 'オフライン',
  
  // Profile
  editProfile: 'プロフィール編集',
  noBioYet: 'まだ自己紹介がありません。',
  followers: 'フォロワー',
  following: 'フォロー中',
  recentActivity: '最近のアクティビティ',
  noPostsYet: 'まだ投稿がありません',
  shareFirstPost: '最初の投稿をシェアしましょう！',
  bio: '自己紹介',
  dateOfBirth: '生年月日',
  follow: 'フォロー',
  unfollow: 'フォロー解除',
  
  // Search
  discover: '発見',
  findPeopleStories: 'あなたにとって重要な人、ストーリー、アイデアを見つけましょう',
  searchByName: '名前、タイトル、または#タグで検索...',
  searchResults: '検索結果',
  noResultsFound: '結果が見つかりません',
  peopleFound: '見つかった人',
  
  // Settings - Additional keys
  enterDisplayName: '表示名を入力してください',
  saving: '保存中...',
  confirmDeleteAccount: 'アカウントを削除してもよろしいですか？この操作は元に戻せません。',
  accountDeletedSuccessfully: 'アカウントが正常に削除されました。',
  errorDeletingAccount: 'アカウントの削除中にエラーが発生しました。もう一度お試しください。',
  settingsSavedSuccessfully: '設定が正常に保存されました！',
  failedToSaveSettings: '設定の保存に失敗しました。もう一度お試しください。',
  
  // Form component
  pleaseSignInToCreate: '投稿を作成するにはサインインしてください。',
  titleRequired: '投稿を公開するにはタイトルが必要です。',
  contentRequired: 'ストーリーコンテンツは投稿を公開するために必要です。',
  contentTooShort: 'ストーリーコンテンツは少なくとも10文字である必要があります。',
  postUpdatedSuccessfully: '投稿が正常に更新されました！',
  postPublishedSuccessfully: '投稿が正常に公開されました！',
  pleaseSignInToCreateBlogs: '自分のIdeaFluxブログを作成するにはサインインしてください。',
  enterEngagingTitle: '魅力的なタイトルを入力...',
  story: 'ストーリー',
  writeYourMasterpiece: 'あなたの傑作を書いてください...',
  addTags: 'タグを追加...',
  add: '追加',
  publishPost: '投稿を公開',
  
  // Post component
  linkCopiedToClipboard: 'リンクがクリップボードにコピーされました！シェア数が更新されました。',
  youAndOthers: 'あなたと他{{count}}人',
  unknownUser: '不明なユーザー',
  noImage: '画像なし',
  deletePost: '投稿を削除',
  confirmDeletePost: 'この投稿を削除してもよろしいですか？',
};